import axiosAuth from "../utils/request";

export async function getCompany() {
  const { data } = await axiosAuth.get("/api/company");
  return data;
}

export async function updateCompany(param) {
  const { data } = await axiosAuth.put("/api/company", param);
  return data;
}

export async function getPasswordPolicy() {
  const { data } = await axiosAuth.get("/api/settingPolicy");
  return data;
}

export async function updatePasswordPolicy(param) {
  const { data } = await axiosAuth.post("/api/settingPolicy", param);
  return data;
}

export async function getSettingAll() {
  const { data } = await axiosAuth.get("/api/setting/all");
  return data;
}

export async function getSettingClosePeriod() {
  const { data } = await axiosAuth.get("/api/setting/closePeriod");
  return data;
}

export async function getSettingSystem() {
  const { data } = await axiosAuth.get("/api/settingSystem");
  return data;
}

export async function getSettingAp() {
  const { data } = await axiosAuth.get("/api/settingAp");
  return data;
}

export async function updateSettingAp(param) {
  const { data } = await axiosAuth.post("/api/settingAp", param);
  return data;
}

export async function getSettingAr() {
  const { data } = await axiosAuth.get("/api/settingAr");
  return data;
}

export async function updateSettingAr(param) {
  const { data } = await axiosAuth.post("/api/settingAr", param);
  return data;
}

export async function getSettingAsset() {
  const { data } = await axiosAuth.get("/api/settingAsset");
  return data;
}

export async function updateSettingAsset(param) {
  const { data } = await axiosAuth.post("/api/settingAsset", param);
  return data;
}

export async function getYearList() {
  const { data } = await axiosAuth.get(`/api/glPeriod`);
  return data;
}

export async function getYearListByYear(year) {
  const { data } = await axiosAuth.get(`/api/glPeriod/year/${year}`);
  return data;
}

export async function getSettingGl() {
  const { data } = await axiosAuth.get("/api/settingGl");
  return data;
}

export async function updateSettingGl(param) {
  const { data } = await axiosAuth.post("/api/settingGl", param);
  return data;
}

export async function updateSettingSystem(param) {
  const { data } = await axiosAuth.post("/api/settingSystem", param);
  return data;
}

//---------------------------- List ----------------------------//

export async function getAccountCodeList(module) {
  let q;
  switch (module) {
    case "Ap":
      q = {
        Limit: 0,
        Page: 1,
        OrderBy: {},
        WhereGroupList: [
          {
            AndOr: "And",
            ConditionList: [
              {
                AndOr: "And",
                Field: "UseInAp",
                Operator: "=",
                Value: true,
              },
              {
                AndOr: "And",
                Field: "AccType",
                Operator: "!=",
                Value: "H",
              },
            ],
          },
        ],
      };
      break;
    case "Ar":
      q = {
        Limit: 0,
        Page: 1,
        OrderBy: {},
        WhereGroupList: [
          {
            AndOr: "And",
            ConditionList: [
              {
                AndOr: "And",
                Field: "UseInAr",
                Operator: "=",
                Value: true,
              },
              {
                AndOr: "And",
                Field: "AccType",
                Operator: "!=",
                Value: "H",
              },
            ],
          },
        ],
      };
      break;
    case "Gl":
      q = {
        Limit: 0,
        Page: 1,
        OrderBy: {},
        WhereGroupList: [
          {
            AndOr: "And",
            ConditionList: [
              {
                AndOr: "And",
                Field: "UseInGl",
                Operator: "=",
                Value: true,
              },
              {
                AndOr: "And",
                Field: "AccType",
                Operator: "!=",
                Value: "H",
              },
            ],
          },
        ],
      };
      break;
    case "Asset":
      q = {
        Limit: 0,
        Page: 1,
        OrderBy: {},
        WhereGroupList: [
          {
            AndOr: "And",
            ConditionList: [
              {
                AndOr: "And",
                Field: "UseInAsset",
                Operator: "=",
                Value: true,
              },
              {
                AndOr: "And",
                Field: "AccType",
                Operator: "!=",
                Value: "H",
              },
            ],
          },
        ],
      };
      break;
    default:
      q = {
        Limit: 0,
        Page: 1,
        OrderBy: {},
        WhereGroupList: [
          {
            AndOr: "And",
            ConditionList: [
              {
                AndOr: "And",
                Field: "AccType",
                Operator: "!=",
                Value: "H",
              },
            ],
          },
        ],
      };
      break;
  }
  const { data } = await axiosAuth.get(
    `/api/accountCode?q=${JSON.stringify(q)}`,
  );
  return data;
}

export async function getDepartmentList() {
  const { data } = await axiosAuth.get("/api/department");
  return data;
}

export async function getCurrencyList() {
  const { data } = await axiosAuth.get("/api/currency");
  return data;
}

export async function getApPaymentTypeList() {
  const { data } = await axiosAuth.get("/api/apPaymentType");
  return data;
}

export async function getApWhtServiceTypeList() {
  const { data } = await axiosAuth.get("/api/apWht");
  return data;
}

export async function getApWhtTypeList() {
  const { data } = await axiosAuth.get("/api/apWhtType");
  return data;
}

export async function getArPaymentTypeList() {
  const { data } = await axiosAuth.get("/api/arPaymentType");
  return data;
}

export async function getUnitList() {
  const { data } = await axiosAuth.get("/api/unit");
  return data;
}

export async function getTenantList() {
  const { data } = await axiosAuth.get("/api/tenant");
  return data;
}

export async function getGblFileFromBank() {
  const { data } = await axiosAuth.get(
    `/api/gblfilefrombank?q=${encodeURI("{limit:0}")}`,
  );
  return data;
}

//---------------------------- Search ----------------------------//
export async function getVdCategoryList() {
  const { data } = await axiosAuth.post("/api/vendorCategory/search", {
    limit: 0,
  });
  return data;
}

export async function getAccountCodeSearchList(uriQueryString) {
  const { data } = await axiosAuth.post(
    "/api/accountCode/search",
    uriQueryString,
  );
  return data;
}

export async function getCurrencySearchList(uriQueryString) {
  const { data } = await axiosAuth.post(
    "/api/currencyexchange/search",
    uriQueryString,
  );
  return data;
}

export async function getDepartmentSearchList(uriQueryString) {
  const { data } = await axiosAuth.post(
    "/api/department/search",
    uriQueryString,
  );
  return data;
}

export async function getPaymentTypeSearchList(uriQueryString) {
  const { data } = await axiosAuth.post(
    "/api/paymentType/search",
    uriQueryString,
  );
  return data;
}

export async function getDimensionSearchList(uriQueryString) {
  const { data } = await axiosAuth.post(
    "/api/dimension/search",
    uriQueryString,
  );
  return data;
}

export async function getUnitSearchList(uriQueryString) {
  const { data } = await axiosAuth.post("/api/unit/search", uriQueryString);
  return data;
}

export async function getVdCategorySearchList(uriQueryString) {
  const { data } = await axiosAuth.post(
    "/api/vendorCategory/search",
    uriQueryString,
  );
  return data;
}

export async function getUserSearchList(uriQueryString) {
  const { data } = await axiosAuth.post("/api/user/search", uriQueryString);
  return data;
}

export async function getSettingBudgetXls() {
  const { data } = await axiosAuth.get("/api/settingBudgetXls");
  return data;
}

export async function updateSettingBudgetXls(param) {
  const { data } = await axiosAuth.put("/api/settingBudgetXls", param);
  return data;
}

//---------------------------- Detail ----------------------------//

export async function getAccountCodeDetail(Id) {
  const { data } = await axiosAuth.get(`/api/accountCode/${Id}`);
  return data;
}

export async function createAccountCodeDetail(param) {
  const { data } = await axiosAuth.post("/api/accountCode", param);
  return data;
}

export async function updateAccountCodeDetail(param) {
  const { data } = await axiosAuth.put(`/api/accountCode/${param.Id}`, param);
  return data;
}

export async function delAccountCodeDetail(Id) {
  const { data } = await axiosAuth.delete(`/api/accountCode/${Id}`);
  return data;
}

export async function getCurrencyDetail(Id) {
  const { data } = await axiosAuth.get(`/api/currency/${Id}`);
  return data;
}

export async function createCurrencyDetail(param) {
  const { data } = await axiosAuth.post("/api/currency", param);
  return data;
}
export async function updateCurrencyDetail(param) {
  const { data } = await axiosAuth.put(`/api/currency/${param.Id}`, param);
  return data;
}

export async function delCurrencyDetail(Id) {
  const { data } = await axiosAuth.delete(`/api/currency/${Id}`);
  return data;
}

export async function getCurrencyExDetail(Id) {
  const { data } = await axiosAuth.get(`/api/currencyexchange/${Id}`);
  return data;
}

export async function createCurrencyExDetail(param) {
  const { data } = await axiosAuth.post("/api/currencyexchange", param);
  return data;
}

export async function updateCurrencyExDetail(param) {
  const { data } = await axiosAuth.put(
    `/api/currencyexchange/${param.Id}`,
    param,
  );
  return data;
}

export async function delCurrencyExDetail(Id) {
  const { data } = await axiosAuth.delete(`/api/currencyexchange/${Id}`);
  return data;
}

export async function getDepartmentDetail(Id) {
  const { data } = await axiosAuth.get(`/api/department/${Id}`);
  return data;
}

export async function createDepartmentDetail(param) {
  const { data } = await axiosAuth.post("/api/department", param);
  return data;
}

export async function updateDepartmentDetail(param) {
  const { data } = await axiosAuth.put(`/api/department/${param.Id}`, param);
  return data;
}

export async function delDepartmentDetail(Id) {
  const { data } = await axiosAuth.delete(`/api/department/${Id}`);
  return data;
}

export async function getPaymentTypeDetail(Id) {
  const { data } = await axiosAuth.get(`/api/paymentType/${Id}`);
  return data;
}

export async function createPaymentTypeDetail(param) {
  const { data } = await axiosAuth.post("/api/paymentType", param);
  return data;
}

export async function updatePaymentTypeDetail(param) {
  const { data } = await axiosAuth.put(`/api/paymentType/${param.Id}`, param);
  return data;
}

export async function delPaymentTypeDetail(Id) {
  const { data } = await axiosAuth.delete(`/api/paymentType/${Id}`);
  return data;
}

export async function getUnitDetail(Id) {
  const { data } = await axiosAuth.get(`/api/unit/${Id}`);
  return data;
}

export async function createUnitDetail(param) {
  const { data } = await axiosAuth.post("/api/unit", param);
  return data;
}

export async function updateUnitDetail(param) {
  const { data } = await axiosAuth.put(`/api/unit/${param.Id}`, param);
  return data;
}

export async function delUnitDetail(Id) {
  const { data } = await axiosAuth.delete(`/api/unit/${Id}`);
  return data;
}

export async function getVdCategoryDetail(Id) {
  const { data } = await axiosAuth.get(`/api/vendorCategory/${Id}`);
  return data;
}

export async function createVdCategoryDetail(param) {
  const { data } = await axiosAuth.post("/api/vendorCategory", param);
  return data;
}

export async function updateVdCategoryDetail(param) {
  const { data } = await axiosAuth.put(
    `/api/vendorCategory/${param.Id}`,
    param,
  );
  return data;
}

export async function delVdCategoryDetail(Id) {
  const { data } = await axiosAuth.delete(`/api/vendorCategory/${Id}`);
  return data;
}

export async function getGblFileFromBankDetail(id) {
  const { data } = await axiosAuth.get(`/api/gblfilefrombank/${id}`);
  return data;
}

export async function createGblFileFromBankDetail(param) {
  const { data } = await axiosAuth.post("/api/gblfilefrombank", param);
  return data;
}

export async function updateGblFileFromBankDetail(param) {
  const { data } = await axiosAuth.put(
    `/api/gblfilefrombank/${param.FileId}`,
    param,
  );
  return data;
}

export async function delGblFileFromBankDetail(id) {
  const { data } = await axiosAuth.delete(`/api/gblfilefrombank/${id}`);
  return data;
}

export async function getMailProfile(code = "NONE") {
  const { data } = await axiosAuth.get(`/api/Mail/Profile/${code}`);
  return data;
}

export async function updatMailProfileCode(code, param) {
  const { data } = await axiosAuth.put(`/api/Mail/Profile/${code}`, param);
  return data;
}

export async function getMailTemplate(code = "NONE") {
  const { data } = await axiosAuth.get(`/api/Mail/Template/${code}`);
  return data;
}

export async function updateMailTemplate(code, param) {
  const { data } = await axiosAuth.put(`/api/Mail/Template/${code}`, param);
  return data;
}

//---------------------------- License ----------------------------//
export async function getLicenseListWithError(showError = false) {
  const { data } = await axiosAuth.get(`/api/licenseInterface/${showError}`);
  return data;
}

export async function getLicenseListAddOnLookup(module = "Unknow") {
  const { data } = await axiosAuth.get(
    `/api/licenseInterface/interfaceList/${module}`,
  );
  return data;
}

export async function getActiveModule() {
  const { data } = await axiosAuth.get("/api/licenseInterface/activeModule");
  return data;
}

export async function getLicenseList() {
  const { data } = await axiosAuth.get("/api/licenseInterface/license");
  return data;
}

export async function updateLicenseAddOns(module, param) {
  const { data } = await axiosAuth.put(
    `/api/licenseInterface/activeModule/${module}`,
    param,
  );
  return data;
}

export async function updateLicenseModule(param) {
  const { data } = await axiosAuth.post("/api/licenseInterface/batch", param);
  return data;
}

//---------------------------- Template Permission ----------------------------//

export async function getTemplatePermissionByLicense() {
  const { data } = await axiosAuth.get("/api/permission/TemplateByLicense");
  return data;
}

export async function getPermissionByBuAndUser(bu, username) {
  const { data } = await axiosAuth.get(`/api/permission/${bu}/${username}`);
  return data;
}

export async function getUpdatePermission(param) {
  const { data } = await axiosAuth.put("/api/permission", param);
  return data;
}

//---------------------------- AddOrDelete ----------------------------//

export async function addOrDeleteTenant(username, tenantId, action) {
  const { data } = await axiosAuth.put(
    `/api/userTenant/addOrDelete?userName=${username}&tenant=${tenantId}&action=${action}`,
  );
  return data;
}

//---------------------------- ProcessLog ----------------------------//
export async function getProcessLogList(uriQueryString) {
  const { data } = await axiosAuth.post(
    "/api/processLog/search",
    uriQueryString,
  );
  return data;
}

//---------------------------- User ----------------------------------//

export async function getUser(username) {
  const q = { Limit: 0, WhereRaw: `username = '${username}'` };
  const { data } = await axiosAuth.get(`/api/user?q=${JSON.stringify(q)}`);
  return data;
}

export async function getUserByUserName(userName) {
  const { data } = await axiosAuth.get(`/api/userTenant/UserName/${userName}`);
  return data;
}

export async function getUserListByTenant(tenant) {
  const { data } = await axiosAuth.get(
    `/api/userTenant/userNameListBy/${tenant}`,
  );
  return data;
}

export async function getTenantByUserName(userName) {
  const { data } = await axiosAuth.get(
    `/api/userTenant/tenantListIn/${localStorage.getItem("adminToken")}/${userName}`,
  );
  return data;
}

export async function updateUserTenantToInActive(param) {
  const { data } = await axiosAuth.put(
    `/api/userTenant/updateToInActive?userName=${param.UserName}&tenant=${param.Tenant}`,
  );
  return data;
}

export async function updateUserTenantToActive(param) {
  const { data } = await axiosAuth.put(
    `/api/userTenant/updateToActive?userName=${param.UserName}&tenant=${param.Tenant}`,
  );
  return data;
}

export async function updatePassword(userId, param) {
  const { data } = await axiosAuth.put(
    `/api/user/changePassword/${userId}`,
    param,
  );
  return data;
}

export async function getUserDetail(userId) {
  const { data } = await axiosAuth.get(`/api/user/${userId}`);
  return data;
}

export async function createUserDetail(param) {
  const { data } = await axiosAuth.post("/api/user", param);
  return data;
}

export async function updateUserDetail(param) {
  const { data } = await axiosAuth.put(`/api/user/${param.UserId}`, param);
  return data;
}

export async function delUserDetail(UserId) {
  const { data } = await axiosAuth.delete(`/api/user/${UserId}`);
  return data;
}

//---------------------------- CurrencyExchangeRate ----------------------------------//
export async function getExchangeRateByProvider(date, base, curr) {
  const fixProvider = "bot";
  const { data } = await axiosAuth.get(
    `/api/currencyexchange/${fixProvider}/${base}/${curr}?date=${date}`,
  );
  return data;
}

//---------------------------- gblparams ----------------------------------//
export async function getGblParams(sections, key) {
  const { data } = await axiosAuth.get(`/api/gblParams/${sections}/${key}`);
  return data;
}

export async function updateGblParams(param) {
  const { data } = await axiosAuth.post(`/api/gblParams`, param);
  return data;
}

//---------------------------- Mock Helpers ----------------------------//

const MOCK_DEPARTMENT_CATEGORY_KEY = "mock_department_categories_v1";
const MOCK_DEPARTMENT_CATEGORY_DEPARTMENT_KEY = "mock_department_category_departments_v1";

const mockDepartmentSeed = [
  { Id: 1, DeptCode: "ADM", Description: "Administration" },
  { Id: 2, DeptCode: "FIN", Description: "Finance" },
  { Id: 3, DeptCode: "HR", Description: "Human Resources" },
  { Id: 4, DeptCode: "FO", Description: "Front Office" },
  { Id: 5, DeptCode: "HK", Description: "Housekeeping" },
  { Id: 6, DeptCode: "FNB", Description: "Food and Beverage" },
];

const mockDepartmentCategorySeed = [
  {
    Id: 1,
    CategoryCode: "OPER",
    CategoryName: "Operations",
    Description: "Operational departments",
    IsActive: true,
    LastModified: "2026-05-07T09:00:00Z",
    UserModified: "system",
  },
  {
    Id: 2,
    CategoryCode: "ADMIN",
    CategoryName: "Administration",
    Description: "Back office departments",
    IsActive: true,
    LastModified: "2026-05-07T09:05:00Z",
    UserModified: "system",
  },
];

const mockDepartmentCategoryAssignmentsSeed = {
  1: [4, 5, 6],
  2: [1, 2, 3],
};

function getStorage() {
  if (typeof window !== "undefined" && window.localStorage) {
    return window.localStorage;
  }
  if (typeof localStorage !== "undefined") {
    return localStorage;
  }
  return null;
}

function cloneMock(value) {
  return JSON.parse(JSON.stringify(value));
}

function readMock(key, seed) {
  const storage = getStorage();
  if (!storage) {
    return cloneMock(seed);
  }

  const raw = storage.getItem(key);
  if (!raw) {
    const initial = cloneMock(seed);
    storage.setItem(key, JSON.stringify(initial));
    return initial;
  }

  try {
    return JSON.parse(raw);
  } catch (error) {
    const initial = cloneMock(seed);
    storage.setItem(key, JSON.stringify(initial));
    return initial;
  }
}

function writeMock(key, value) {
  const storage = getStorage();
  if (storage) {
    storage.setItem(key, JSON.stringify(value));
  }
  return value;
}

function getMockNow() {
  return new Date().toISOString();
}

function getNextMockId(items) {
  return items.reduce((max, item) => Math.max(max, Number(item?.Id) || 0), 0) + 1;
}

function successResponse(message, internalMessage = "") {
  return {
    Code: 0,
    UserMessage: message,
    InternalMessage: internalMessage,
  };
}

function warningResponse(message, internalMessage = "") {
  return {
    Code: 1,
    UserMessage: message,
    InternalMessage: internalMessage,
  };
}

function normalizeKeyword(value) {
  return String(value || "").trim().toLowerCase();
}

function stripWildcard(value) {
  return String(value || "").replace(/%/g, "");
}

function getMockUserName() {
  return getStorage()?.getItem("UserName") || "mock-user";
}

function applyMockSearch(items, uriQueryString, fields) {
  const keyword = normalizeKeyword(stripWildcard(uriQueryString?.WhereLike));
  if (!keyword) {
    return [...items];
  }

  const targetFields =
    uriQueryString?.WhereLikeFields?.length > 0 ? uriQueryString.WhereLikeFields : fields;

  return items.filter((item) =>
    targetFields.some((field) =>
      String(item?.[field] ?? "")
        .toLowerCase()
        .includes(keyword),
    ),
  );
}

function applyMockSort(items, orderBy) {
  const [field, direction] = Object.entries(orderBy || {})[0] || [];
  if (!field) {
    return [...items];
  }

  return [...items].sort((left, right) => {
    const leftValue = left?.[field];
    const rightValue = right?.[field];

    if (leftValue == null && rightValue == null) return 0;
    if (leftValue == null) return direction === "desc" ? 1 : -1;
    if (rightValue == null) return direction === "desc" ? -1 : 1;

    if (typeof leftValue === "number" && typeof rightValue === "number") {
      return direction === "desc" ? rightValue - leftValue : leftValue - rightValue;
    }

    const compare = String(leftValue).localeCompare(String(rightValue), undefined, {
      numeric: true,
      sensitivity: "base",
    });
    return direction === "desc" ? compare * -1 : compare;
  });
}

function buildMockPaging(items, uriQueryString) {
  const limit = Number(uriQueryString?.Limit) || 15;
  const page = Number(uriQueryString?.Page) || 1;
  const totalRecordCount = items.length;
  const start = limit > 0 ? (page - 1) * limit : 0;
  const pagedData = limit > 0 ? items.slice(start, start + limit) : items;

  return {
    Data: pagedData,
    Paging: {
      Limit: limit,
      Page: page,
      TotalRecordCount: totalRecordCount,
      TotalPage: limit > 0 ? Math.max(1, Math.ceil(totalRecordCount / limit)) : 1,
    },
  };
}

function getMockDepartmentCategories() {
  return readMock(MOCK_DEPARTMENT_CATEGORY_KEY, mockDepartmentCategorySeed);
}

function saveMockDepartmentCategories(items) {
  return writeMock(MOCK_DEPARTMENT_CATEGORY_KEY, items);
}

function getMockDepartmentAssignments() {
  return readMock(
    MOCK_DEPARTMENT_CATEGORY_DEPARTMENT_KEY,
    mockDepartmentCategoryAssignmentsSeed,
  );
}

function saveMockDepartmentAssignments(items) {
  return writeMock(MOCK_DEPARTMENT_CATEGORY_DEPARTMENT_KEY, items);
}

function getMockDepartmentByIds(ids) {
  return mockDepartmentSeed.filter((item) => ids.includes(item.Id));
}

function mapDepartmentCategoryListItem(category, assignments) {
  const deptIds = assignments[category.Id] || [];
  return {
    ...category,
    DeptCount: deptIds.length,
  };
}

function getMockDepartmentCategoryDetailRecord(id) {
  const categories = getMockDepartmentCategories();
  const assignments = getMockDepartmentAssignments();
  const item = categories.find((category) => Number(category.Id) === Number(id));
  if (!item) {
    return null;
  }

  const deptIds = assignments[item.Id] || [];
  return {
    ...item,
    Departments: getMockDepartmentByIds(deptIds),
    DeptCount: deptIds.length,
  };
}

function getMockUnassignedDepartments() {
  const assignments = getMockDepartmentAssignments();
  const usedIds = Object.values(assignments).flat();
  return mockDepartmentSeed.filter((item) => !usedIds.includes(item.Id));
}

//---------------------------- Department Category ----------------------------//

export async function getDepartmentCategoryList() {
  const assignments = getMockDepartmentAssignments();
  const data = getMockDepartmentCategories().map((item) =>
    mapDepartmentCategoryListItem(item, assignments),
  );
  return { Data: data };
}

export async function getDepartmentCategorySearchList(uriQueryString) {
  const assignments = getMockDepartmentAssignments();
  const items = getMockDepartmentCategories().map((item) =>
    mapDepartmentCategoryListItem(item, assignments),
  );
  const filtered = applyMockSearch(items, uriQueryString, [
    "CategoryCode",
    "CategoryName",
    "Description",
  ]);
  const ordered = applyMockSort(filtered, uriQueryString?.OrderBy);
  return buildMockPaging(ordered, uriQueryString);
}

export async function getDepartmentCategoryDetail(Id) {
  return getMockDepartmentCategoryDetailRecord(Id);
}

export async function createDepartmentCategoryDetail(param) {
  const categories = getMockDepartmentCategories();
  const duplicate = categories.find(
    (item) =>
      normalizeKeyword(item.CategoryCode) === normalizeKeyword(param?.CategoryCode) ||
      normalizeKeyword(item.CategoryName) === normalizeKeyword(param?.CategoryName),
  );

  if (duplicate) {
    return warningResponse("Department category code or name already exists.");
  }

  const newId = getNextMockId(categories);
  const newItem = {
    Id: newId,
    CategoryCode: param?.CategoryCode || "",
    CategoryName: param?.CategoryName || "",
    Description: param?.Description || "",
    IsActive: param?.IsActive ?? true,
    LastModified: getMockNow(),
    UserModified: param?.UserModified || getMockUserName(),
  };

  categories.push(newItem);
  saveMockDepartmentCategories(categories);
  return successResponse("Department category created successfully.", String(newId));
}

export async function updateDepartmentCategoryDetail(param) {
  const categories = getMockDepartmentCategories();
  const index = categories.findIndex((item) => Number(item.Id) === Number(param?.Id));

  if (index === -1) {
    return warningResponse("Department category not found.");
  }

  const duplicate = categories.find(
    (item) =>
      Number(item.Id) !== Number(param?.Id) &&
      (normalizeKeyword(item.CategoryCode) === normalizeKeyword(param?.CategoryCode) ||
        normalizeKeyword(item.CategoryName) === normalizeKeyword(param?.CategoryName)),
  );

  if (duplicate) {
    return warningResponse("Department category code or name already exists.");
  }

  categories[index] = {
    ...categories[index],
    ...param,
    LastModified: getMockNow(),
  };
  saveMockDepartmentCategories(categories);
  return successResponse("Department category updated successfully.", String(param.Id));
}

export async function delDepartmentCategoryDetail(Id) {
  const categories = getMockDepartmentCategories();
  const assignments = getMockDepartmentAssignments();
  const assignedIds = assignments[Id] || [];

  if (assignedIds.length > 0) {
    return warningResponse("Please remove assigned departments before deleting this category.");
  }

  saveMockDepartmentCategories(
    categories.filter((item) => Number(item.Id) !== Number(Id)),
  );
  delete assignments[Id];
  saveMockDepartmentAssignments(assignments);
  return successResponse("Department category deleted successfully.");
}

export async function getDepartmentCategoryAvailableList() {
  return { Data: getMockUnassignedDepartments() };
}

export async function assignDepartmentToCategory(param) {
  const { CategoryId, DepartmentIds = [] } = param || {};
  const categories = getMockDepartmentCategories();
  const category = categories.find((item) => Number(item.Id) === Number(CategoryId));
  if (!category) {
    return warningResponse("Department category not found.");
  }

  const assignments = getMockDepartmentAssignments();
  const assignedElsewhere = Object.entries(assignments).flatMap(([key, ids]) =>
    Number(key) === Number(CategoryId) ? [] : ids,
  );
  const conflict = DepartmentIds.find((id) => assignedElsewhere.includes(id));

  if (conflict) {
    return warningResponse("One or more departments are already assigned to another category.");
  }

  const current = assignments[CategoryId] || [];
  assignments[CategoryId] = Array.from(new Set([...current, ...DepartmentIds]));
  category.LastModified = getMockNow();
  saveMockDepartmentAssignments(assignments);
  saveMockDepartmentCategories(categories);
  return successResponse("Departments assigned successfully.");
}

export async function removeDepartmentFromCategory(param) {
  const { CategoryId, DepartmentIds = [] } = param || {};
  const assignments = getMockDepartmentAssignments();
  assignments[CategoryId] = (assignments[CategoryId] || []).filter(
    (id) => !DepartmentIds.includes(id),
  );
  saveMockDepartmentAssignments(assignments);
  return successResponse("Departments removed successfully.");
}

//---------------------------- Account Grouping ----------------------------//

function toAccountGroupLevelNumber(level) {
  if (typeof level === "number" && Number.isFinite(level)) {
    return level;
  }

  if (typeof level === "string") {
    const match = level.match(/\d+/);
    if (match) {
      return Number(match[0]);
    }
  }

  return 1;
}

function toAccountGroupLevelString(level) {
  const normalized = Math.min(Math.max(toAccountGroupLevelNumber(level), 1), 4);
  return `L${normalized}`;
}

function normalizeAccountGroupNode(group, depth = null) {
  const accountList = group?.Account || group?.Accounts || [];
  const numericLevel = depth ?? toAccountGroupLevelNumber(group?.Level);
  const normalized = {
    ...group,
    Id: group?.AccGroupId ?? group?.Id,
    AccGroupId: group?.AccGroupId ?? group?.Id,
    GroupCode: group?.AccGroupCode ?? group?.GroupCode ?? "",
    GroupName: group?.AccGroupName ?? group?.GroupName ?? "",
    AccGroupCode: group?.AccGroupCode ?? group?.GroupCode ?? "",
    AccGroupName: group?.AccGroupName ?? group?.GroupName ?? "",
    ParentGroupId: group?.ParentId ?? group?.ParentGroupId ?? null,
    ParentId: group?.ParentId ?? group?.ParentGroupId ?? null,
    Level: numericLevel,
    LevelNo: numericLevel,
    ApiLevel: toAccountGroupLevelString(group?.Level ?? numericLevel),
    Account: accountList,
    Accounts: accountList,
    Children: [],
  };

  return normalized;
}

function buildAccountGroupTreeFromFlatList(items = []) {
  const normalizedItems = (items || []).map((item) => normalizeAccountGroupNode(item));
  const nodeMap = new Map();
  const roots = [];

  normalizedItems.forEach((item) => {
    nodeMap.set(Number(item.AccGroupId), item);
  });

  normalizedItems.forEach((item) => {
    const parentId = item.ParentId;
    if (parentId != null && nodeMap.has(Number(parentId))) {
      nodeMap.get(Number(parentId)).Children.push(item);
    } else {
      roots.push(item);
    }
  });

  const sortNodes = (nodes) => {
    nodes.sort((left, right) =>
      `${left.AccGroupCode}${left.AccGroupName}`.localeCompare(
        `${right.AccGroupCode}${right.AccGroupName}`,
        undefined,
        { numeric: true, sensitivity: "base" },
      ),
    );

    nodes.forEach((node) => {
      node.Children = sortNodes(node.Children || []);
    });
    return nodes;
  };

  const withDepth = (nodes, depth = 1) =>
    (nodes || []).map((node) => ({
      ...node,
      Level: depth,
      LevelNo: depth,
      Children: withDepth(node.Children || [], depth + 1),
    }));

  return withDepth(sortNodes(roots), 1);
}

function buildApiResponse(code, userMessage, internalMessage = "", moreInfo = "") {
  return {
    Code: code,
    UserMessage: userMessage,
    InternalMessage: internalMessage,
    MoreInfo: moreInfo,
  };
}

function normalizeAccountCodes(param) {
  const fromParam = param?.AccCode || param?.AccountCodes || [];
  const fromDetail = [
    ...(param?.Account || []).map((item) => item?.AccCode).filter(Boolean),
    ...(param?.Accounts || []).map((item) => item?.AccCode).filter(Boolean),
  ];

  return Array.from(new Set([...(fromParam || []), ...fromDetail].filter(Boolean)));
}

function toAccountGroupPayload(param = {}, fallback = {}) {
  return {
    AccGroupCode:
      param?.AccGroupCode ??
      param?.GroupCode ??
      fallback?.AccGroupCode ??
      fallback?.GroupCode ??
      "",
    AccGroupName:
      param?.AccGroupName ??
      param?.GroupName ??
      fallback?.AccGroupName ??
      fallback?.GroupName ??
      "",
    Level: toAccountGroupLevelString(
      param?.Level ?? fallback?.Level ?? fallback?.LevelNo ?? 1,
    ),
    ParentId:
      param?.ParentId ??
      param?.ParentGroupId ??
      fallback?.ParentId ??
      fallback?.ParentGroupId ??
      null,
    AccCode: normalizeAccountCodes(param).length
      ? normalizeAccountCodes(param)
      : normalizeAccountCodes(fallback),
    UserModified:
      param?.UserModified ??
      fallback?.UserModified ??
      localStorage.getItem("UserName") ??
      "",
  };
}

async function updateAccountGroupAccounts(groupId, nextCodes) {
  const detail = await getAccountGroupingDetail(groupId);
  if (!detail) {
    return buildApiResponse(1, "Account grouping not found.");
  }

  return updateAccountGroupingDetail({
    ...detail,
    AccGroupId: detail.AccGroupId,
    AccCode: nextCodes,
  });
}

export async function getAccountGroupingTree() {
  const { Data } = await getAccountGroupingSearchList({
    Limit: 0,
    Page: 1,
    OrderBy: { AccGroupCode: "asc" },
  });

  return { Data: buildAccountGroupTreeFromFlatList(Data || []) };
}

export async function getAccountGroupingSearchList(uriQueryString) {
  const { data } = await axiosAuth.post(
    "/api/accountGroup/search",
    uriQueryString,
  );
  return data;
}

export async function getAccountGroupingDetail(Id) {
  const { data } = await axiosAuth.get(`/api/AccountGroup/${Id}`);
  console.log("Fetched account grouping detail:", data);
  if (!data) {
    return null;
  }

  return normalizeAccountGroupNode(data);
}

export async function createAccountGroupingDetail(param) {
  const payload = toAccountGroupPayload(param);
  const { data } = await axiosAuth.post("/api/AccountGroup", payload);
  return data;
}

export async function updateAccountGroupingDetail(param) {
  const groupId = param?.AccGroupId ?? param?.Id;
  const payload = toAccountGroupPayload(param);
  const { data } = await axiosAuth.put(
    `/api/AccountGroup/${groupId}`,
    payload,
  );
  return data;
}

export async function delAccountGroupingDetail(Id) {
  const { data } = await axiosAuth.delete(`/api/AccountGroup/${Id}`);
  return data;
}

export async function getAccountGroupingAvailableList() {
  const { Data } = await getAccountCodeSearchList({
    Limit: 0,
    Page: 1,
    OrderBy: { AccCode: "asc" },
  });
  return { Data };
}

export async function assignAccountToGroup(param) {
  const groupId = param?.GroupId ?? param?.AccGroupId ?? param?.Id;
  const accountCodes = normalizeAccountCodes(param);
  const detail = await getAccountGroupingDetail(groupId);

  if (!detail) {
    return buildApiResponse(1, "Account grouping not found.");
  }

  const currentCodes = normalizeAccountCodes(detail);
  const nextCodes = Array.from(new Set([...currentCodes, ...accountCodes]));
  return updateAccountGroupAccounts(groupId, nextCodes);
}

export async function removeAccountFromGroup(param) {
  const groupId = param?.GroupId ?? param?.AccGroupId ?? param?.Id;
  const accountCodes = normalizeAccountCodes(param);
  const detail = await getAccountGroupingDetail(groupId);

  if (!detail) {
    return buildApiResponse(1, "Account grouping not found.");
  }

  const currentCodes = normalizeAccountCodes(detail);
  const nextCodes = currentCodes.filter((code) => !accountCodes.includes(code));
  return updateAccountGroupAccounts(groupId, nextCodes);
}

export async function moveAccountBetweenGroups(param) {
  const fromGroupId = param?.FromGroupId ?? param?.GroupId ?? param?.AccGroupId;
  const toGroupId = param?.ToGroupId;
  const accountCodes = normalizeAccountCodes(param);

  if (Number(fromGroupId) === Number(toGroupId)) {
    return buildApiResponse(1, "Source and target group cannot be the same.");
  }

  const fromDetail = await getAccountGroupingDetail(fromGroupId);
  const toDetail = await getAccountGroupingDetail(toGroupId);

  if (!fromDetail || !toDetail) {
    return buildApiResponse(1, "Account grouping not found.");
  }

  const fromCodes = normalizeAccountCodes(fromDetail).filter(
    (code) => !accountCodes.includes(code),
  );
  const toCodes = Array.from(
    new Set([...normalizeAccountCodes(toDetail), ...accountCodes]),
  );

  const fromResponse = await updateAccountGroupAccounts(fromGroupId, fromCodes);
  if (fromResponse?.Code !== 0) {
    return fromResponse;
  }

  const toResponse = await updateAccountGroupAccounts(toGroupId, toCodes);
  return toResponse;
}

export async function moveGroupToParent(param) {
  const groupId = param?.GroupId ?? param?.AccGroupId ?? param?.Id;
  const newParentId = param?.NewParentGroupId ?? param?.ParentId ?? null;
  const detail = await getAccountGroupingDetail(groupId);

  if (!detail) {
    return buildApiResponse(1, "Account grouping not found.");
  }

  if (Number(groupId) === Number(newParentId)) {
    return buildApiResponse(1, "A group cannot be moved under itself.");
  }

  let nextLevel = 1;
  if (newParentId != null && newParentId !== "") {
    const parentDetail = await getAccountGroupingDetail(newParentId);
    if (!parentDetail) {
      return buildApiResponse(1, "Account grouping not found.");
    }
    nextLevel = toAccountGroupLevelNumber(parentDetail.Level) + 1;
  }

  if (nextLevel > 4) {
    return buildApiResponse(1, "Maximum grouping level is 4.");
  }

  return updateAccountGroupingDetail({
    ...detail,
    AccGroupId: detail.AccGroupId,
    ParentId: newParentId ?? null,
    Level: toAccountGroupLevelString(nextLevel),
  });
}

//---------------------------- TaxAllocation ----------------------------------//
export async function getTaxAllocation() {
  const { data } = await axiosAuth.get(`/api/TaxAllocation`);
  return data;
}

export async function updateTaxAllocation(param) {
  const { data } = await axiosAuth.put(`/api/TaxAllocation`, param);
  return data;
}
